//import Dashboard from "@material-ui/icons/Dashboard";
//import DashboardPage from "views/Dashboard/Dashboard.js";
import ManageAccounts from "@mui/icons-material/ManageAccounts";
import AirportShuttleIcon from "@mui/icons-material/AirportShuttle";
import LocalShippingIcon from "@mui/icons-material/LocalShipping";
import DirectionsBusIcon from "@mui/icons-material/DirectionsBus";
import NoteAddIcon from "@mui/icons-material/NoteAdd";
import ModelTrainingIcon from "@mui/icons-material/ModelTraining";
import AppRegistrationIcon from "@mui/icons-material/AppRegistration";
import EmojiTransportationIcon from "@mui/icons-material/EmojiTransportation";
import TramIcon from "@mui/icons-material/Tram";
import BarChartIcon from "@mui/icons-material/BarChart";
import FactCheckIcon from "@mui/icons-material/FactCheck";
import MenuBookIcon from "@mui/icons-material/MenuBook";
import InfoIcon from "@mui/icons-material/Info";
import AttachMoneyIcon from "@mui/icons-material/AttachMoney";
import Taxi from "views/Taxi/Taxi.js";
import Xedien from "views/Xedien/Xedien.js";
//import Xedulich from "views/Xedulich/Xedulich.js";
import Xehopdong from "views/Xehopdong/Xehopdong.js";
import Xetuyencodinh from "views/Xetuyencodinh/Xetuyencodinh.js";
import Xebuyt from "views/Xebuyt/Xebuyt.js";
//import Hopdongvantaihanhkhach from "views/Hopdongvantai/Hopdongvantaihanhkhach.js";
import Vantaihanghoathongthuong from "views/Vantaihanghoa/Vantaihanghoathongthuong.js";
import Vantaihanghoacontainer from "views/Vantaihanghoa/Vantaihanghoacontainer.js";
import Giayvantai from "views/Giayvantai/Giayvantai.js";
import Benxekhachthang from "views/Benxe/Benxekhachthang.js";
//import Benxehangthang from "views/Benxe/Benxehangthang.js";
import Dangkiem from "views/Dangkiem/Dangkiem.js";
import Baocaovantaihanhkhach from "views/Baocao/Baocaovantaihanhkhach.js";
import Baocaovantaihanghoa from "views/Baocao/Baocaovantaihanghoa.js";
import Baocaobenxe from "views/Baocao/Baocaobenxe.js";
import BaocaophuongtienGT from "views/Baocao/BaocaophuongtienGT.js";
import Baocaodangkiem from "views/Baocao/Baocaodangkiem.js";
import Thongkevantaihanhkhach from "views/Thongke/Thongkevantaihanhkhach.js";
import Thongkevantaihanghoa from "views/Thongke/Thongkevantaihanghoa.js";
import Thongkebenxe from "views/Thongke/Thongkebenxe.js";
import Thongkedangkiem from "views/Thongke/Thongkedangkiem.js";
import Thongkexedien from "views/Thongke/Thongkexedien.js";
import ThongkephuongtienGT from "views/Thongke/ThongkephuongtienGT.js";
import Thongkequanlydaotao from "views/Thongke/Thongkequanlydaotao.js";
import Thongkelaixe from "views/Thongke/Thongkelaixe.js";
import Thongkegiayvantai from "views/Thongke/Thongkegiayvantai.js";
import Thongkethue from "views/Thongke/Thongkethue.js";
import Thongkephuluc9 from "views/Thongke/Thongkephuluc9.js";
import Phuongtiengiaothong from "views/Phuongtiengiaothong/Phuongtiengiaothong.js";
import Quanlydaotao from "views/Quanlydaotao/Quanlydaotao.js";
import Baocaoxedien from "views/Baocao/Baocaoxedien.js";
import Importfile from "views/Importfile/Importfile.js";
import Maubaocao18 from "views/Tonghopbaocao/Maubaocao18.js";
import Maubaocao19 from "views/Tonghopbaocao/Maubaocao19.js";
import Maubaocao20 from "views/Tonghopbaocao/Maubaocao20.js";
import Phulucxedien from "views/Tonghopbaocao/Phulucxedien.js";
import Danhsachvanban from "views/Danhsachvanban/Danhsachvanban.js";
import Thongtinlaixe from "views/Danhmuc/Thongtinlaixe.js";
import DNtracuuthongtin from "views/Tracuuthongtin/DNtracuuthongtin.js";
import Tonghopbaocao from "views/Tonghopbaocao/Tonghopbaocao.js";
import Thongtinthue from "views/Thongtinthue/Thongtinthue.js";
import GiaychungnhanDKKD from "views/GiaychungnhanDKKD/GiaychungnhanDKKD.js";
import Phuluc9 from "views/Phuluc9/Phuluc9.js";
import Phuluc10 from "views/Phuluc10/Phuluc10.js";

const dashboardRoutes = [
  {
    path: "/danhsachvanban",
    name: "Văn bản",
    rtlName: "قائمة الجدول",
    icon: MenuBookIcon,
    layout: "/admin",
    component: Danhsachvanban,
    sub: 0,
  },
  {
    path: "/thongtinlaixe",
    name: "Thông tin lái xe",
    rtlName: "قائمة الجدول",
    icon: ManageAccounts,
    component: Thongtinlaixe,
    layout: "/admin",
    sub: 0,
  },
  {
    path: "/doanhnghieptracuuthongtin",
    name: "Thông tin doanh nghiệp",
    rtlName: "قائمة الجدول",
    icon: InfoIcon,
    component: DNtracuuthongtin,
    layout: "/admin",
    sub: 0,
  },
  {
    path: "/thongtinthue",
    name: "Thông tin về thuế",
    rtlName: "قائمة الجدول",
    icon: AttachMoneyIcon,
    component: Thongtinthue,
    layout: "/admin",
    sub: 0,
  },
  {
    path: "/phuluc9",
    name: "Thông tin phụ lục 9",
    rtlName: "قائمة الجدول",
    icon: InfoIcon,
    component: Phuluc9,
    layout: "/admin",
    sub: 0,
  },
  {
    path: "/phuluc10",
    name: "Thông tin phụ lục 10",
    rtlName: "قائمة الجدول",
    icon: InfoIcon,
    component: Phuluc10,
    layout: "/admin",
    sub: 0,
  },
  {
    path: "/giaychungnhandkkd",
    name: "Thông tin giấy CNĐKKD",
    rtlName: "قائمة الجدول",
    icon: InfoIcon,
    component: GiaychungnhanDKKD,
    layout: "/admin",
    sub: 0,
  },
  {
    path: "/submenuvantaihanhkhach",
    name: "Vận tải hành khách",
    rtlName: "قائمة الجدول",
    icon: AirportShuttleIcon,
    layout: "/admin",
    sub: 1,
    id: 1,
  },
  {
    path: "/taxi",
    name: "Taxi",
    rtlName: "قائمة الجدول",
    icon: ManageAccounts,
    component: Taxi,
    layout: "/admin",
    parent: 1,
  },
  /*{
    path: "/xedulich",
    name: "Xe du lịch",
    rtlName: "قائمة الجدول",
    icon: ManageAccounts,
    component: Xedulich,
    layout: "/admin",
    parent: 1,
  },*/
  {
    path: "/xehopdong",
    name: "Xe hợp đồng",
    rtlName: "قائمة الجدول",
    icon: ManageAccounts,
    component: Xehopdong,
    layout: "/admin",
    parent: 1,
  },
  {
    path: "/xetuyencodinh",
    name: "Xe tuyến cố định",
    rtlName: "قائمة الجدول",
    icon: ManageAccounts,
    component: Xetuyencodinh,
    layout: "/admin",
    parent: 1,
  },
  {
    path: "/xebuyt",
    name: "Xe buýt",
    rtlName: "قائمة الجدول",
    icon: ManageAccounts,
    component: Xebuyt,
    layout: "/admin",
    parent: 1,
  },
  /*{
    path: "/hopdongvantaihanhkhach",
    name: "Hợp đồng vận tải hành khách",
    rtlName: "قائمة الجدول",
    icon: ManageAccounts,
    component: Hopdongvantaihanhkhach,
    layout: "/admin",
    parent: 1,
  },*/
  {
    path: "/submenuvantaihanghoa",
    name: "Vận tải hàng hóa",
    rtlName: "قائمة الجدول",
    icon: LocalShippingIcon,
    layout: "/admin",
    sub: 1,
    id: 2,
  },
  {
    path: "/vantaihanghoathongthuong",
    name: "Vận tải HH thông thường",
    rtlName: "قائمة الجدول",
    icon: ManageAccounts,
    component: Vantaihanghoathongthuong,
    layout: "/admin",
    parent: 2,
  },
  {
    path: "/vantaihanghoacontainer",
    name: "Vận tải HH bằng Container",
    rtlName: "قائمة الجدول",
    icon: ManageAccounts,
    component: Vantaihanghoacontainer,
    layout: "/admin",
    parent: 2,
  },
  {
    path: "/giayvantai",
    name: "Giấy vận tải",
    rtlName: "قائمة الجدول",
    icon: ManageAccounts,
    component: Giayvantai,
    layout: "/admin",
    parent: 2,
  },
  {
    path: "/submenubenxe",
    name: "Bến xe",
    rtlName: "قائمة الجدول",
    icon: DirectionsBusIcon,
    layout: "/admin",
    sub: 1,
    id: 6,
  },
  {
    path: "/benxekhachthang",
    name: "Báo cáo bến xe khách",
    rtlName: "قائمة الجدول",
    icon: BarChartIcon,
    component: Benxekhachthang,
    layout: "/admin",
    parent: 6,
  },
  {
    path: "/importfile",
    name: "Import file",
    rtlName: "قائمة الجدول",
    icon: NoteAddIcon,
    component: Importfile,
    layout: "/admin",
    parent: 6,
  },
  /*{
    path: "/benxehangthang",
    name: "Báo cáo bến xe hàng",
    rtlName: "قائمة الجدول",
    icon: BarChartIcon,
    component: Benxehangthang,
    layout: "/admin",
    parent: 6,
  },*/
  {
    path: "/quanlydaotao",
    name: "Quản lý đào tạo",
    rtlName: "قائمة الجدول",
    icon: ModelTrainingIcon,
    component: Quanlydaotao,
    layout: "/admin",
    sub: 0,
  },
  {
    path: "/dangkiem",
    name: "Thông tin đăng kiểm",
    rtlName: "قائمة الجدول",
    icon: AppRegistrationIcon,
    component: Dangkiem,
    layout: "/admin",
    sub: 0,
  },
  {
    path: "/xedien",
    name: "Xe điện bốn bánh",
    rtlName: "قائمة الجدول",
    icon: TramIcon,
    component: Xedien,
    layout: "/admin",
    sub: 0,
  },
  {
    path: "/phuongtiengiaothong",
    name: "Phương tiện đăng ký",
    rtlName: "قائمة الجدول",
    icon: EmojiTransportationIcon,
    component: Phuongtiengiaothong,
    layout: "/admin",
    sub: 0,
  },
  {
    path: "/submenubaocaophuluc",
    name: "Xuất báo cáo phụ lục",
    rtlName: "قائمة الجدول",
    icon: BarChartIcon,
    layout: "/admin",
    sub: 1,
    id: 3,
  },
  {
    path: "/maubaocao18",
    name: "Mẫu báo cáo phụ lục 16",
    rtlName: "قائمة الجدول",
    icon: ManageAccounts,
    component: Maubaocao18,
    layout: "/admin",
    parent: 3,
  },
  {
    path: "/maubaocao19",
    name: "Mẫu báo cáo phụ lục 17",
    rtlName: "قائمة الجدول",
    icon: ManageAccounts,
    component: Maubaocao19,
    layout: "/admin",
    parent: 3,
  },
  {
    path: "/maubaocao20",
    name: "Mẫu báo cáo phụ lục 18",
    rtlName: "قائمة الجدول",
    icon: ManageAccounts,
    component: Maubaocao20,
    layout: "/admin",
    parent: 3,
  },
  {
    path: "/phulucxedien",
    name: "Mẫu phụ lục xe điện",
    rtlName: "قائمة الجدول",
    icon: ManageAccounts,
    component: Phulucxedien,
    layout: "/admin",
    parent: 3,
  },
  {
    path: "/submenuthongke",
    name: "Tra cứu",
    rtlName: "قائمة الجدول",
    icon: FactCheckIcon,
    layout: "/admin",
    sub: 1,
    id: 4,
  },
  {
    path: "/thongkevantaihanhkhach",
    name: "Vận tải hành khách",
    rtlName: "قائمة الجدول",
    icon: ManageAccounts,
    component: Thongkevantaihanhkhach,
    layout: "/admin",
    parent: 4,
  },
  {
    path: "/thongkevantaihanghoa",
    name: "Vận tải hàng hóa",
    rtlName: "قائمة الجدول",
    icon: ManageAccounts,
    component: Thongkevantaihanghoa,
    layout: "/admin",
    parent: 4,
  },
  {
    path: "/thongkebenxe",
    name: "Bến xe",
    rtlName: "قائمة الجدول",
    icon: ManageAccounts,
    component: Thongkebenxe,
    layout: "/admin",
    parent: 4,
  },
  {
    path: "/thongkedangkiem",
    name: "Thống kê đăng kiểm",
    rtlName: "قائمة الجدول",
    icon: ManageAccounts,
    component: Thongkedangkiem,
    layout: "/admin",
    parent: 4,
  },
  {
    path: "/thongkequanlydaotao",
    name: "Quản lý đào tạo",
    rtlName: "قائمة الجدول",
    icon: ManageAccounts,
    component: Thongkequanlydaotao,
    layout: "/admin",
    parent: 4,
  },
  {
    path: "/thongkexedien",
    name: "Xe điện bốn bánh",
    rtlName: "قائمة الجدول",
    icon: ManageAccounts,
    component: Thongkexedien,
    layout: "/admin",
    parent: 4,
  },
  {
    path: "/thongkephuongtiengiaothong",
    name: "Phương tiện đăng ký",
    rtlName: "قائمة الجدول",
    icon: ManageAccounts,
    component: ThongkephuongtienGT,
    layout: "/admin",
    parent: 4,
  },
  {
    path: "/thongkelaixe",
    name: "Thống kê lái xe",
    rtlName: "قائمة الجدول",
    icon: ManageAccounts,
    component: Thongkelaixe,
    layout: "/admin",
    parent: 4,
  },
  {
    path: "/thongkegiayvantai",
    name: "Thống kê giấy vận tải",
    rtlName: "قائمة الجدول",
    icon: ManageAccounts,
    component: Thongkegiayvantai,
    layout: "/admin",
    parent: 4,
  },
  {
    path: "/thongkethue",
    name: "Thống kê thông tin thuế",
    rtlName: "قائمة الجدول",
    icon: ManageAccounts,
    component: Thongkethue,
    layout: "/admin",
    parent: 4,
  },
  {
    path: "/thongkephuluc9",
    name: "Thống kê phụ lục 9",
    rtlName: "قائمة الجدول",
    icon: ManageAccounts,
    component: Thongkephuluc9,
    layout: "/admin",
    parent: 4,
  },
  {
    path: "/submenubaocao",
    name: "Báo cáo",
    rtlName: "قائمة الجدول",
    icon: BarChartIcon,
    layout: "/admin",
    sub: 1,
    id: 5,
  },
  {
    path: "/tonghopbaocao",
    name: "Báo cáo theo phụ lục",
    rtlName: "قائمة الجدول",
    icon: BarChartIcon,
    component: Tonghopbaocao,
    layout: "/admin",
    parent: 5,
  },
  {
    path: "/baocaovantaihanhkhach",
    name: "Vận tải hành khách",
    rtlName: "قائمة الجدول",
    icon: ManageAccounts,
    component: Baocaovantaihanhkhach,
    layout: "/admin",
    parent: 5,
  },
  {
    path: "/baocaovantaihanghoa",
    name: "Vận tải hàng hóa",
    rtlName: "قائمة الجدول",
    icon: ManageAccounts,
    component: Baocaovantaihanghoa,
    layout: "/admin",
    parent: 5,
  },
  {
    path: "/baocaobenxe",
    name: "Báo cáo bến xe",
    rtlName: "قائمة الجدول",
    icon: ManageAccounts,
    component: Baocaobenxe,
    layout: "/admin",
    parent: 5,
  },
  {
    path: "/baocaoxedien",
    name: "Báo cáo xe điện",
    rtlName: "قائمة الجدول",
    icon: ManageAccounts,
    component: Baocaoxedien,
    layout: "/admin",
    parent: 5,
  },
  {
    path: "/baocaophuongtiengiaothong",
    name: "Phương tiện đăng ký",
    rtlName: "قائمة الجدول",
    icon: ManageAccounts,
    component: BaocaophuongtienGT,
    layout: "/admin",
    parent: 5,
  },
  {
    path: "/baocaodangkiem",
    name: "Đăng kiểm",
    rtlName: "قائمة الجدول",
    icon: ManageAccounts,
    component: Baocaodangkiem,
    layout: "/admin",
    parent: 5,
  },
];

export default dashboardRoutes;
